<div>
  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''" aria-label="Close"></button>
  </div>

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-graph-up me-2"></i>
      Agremo Analyses
      <span *ngIf="!loading" class="badge bg-secondary ms-2">{{ totalAnalyses }}</span>
    </h5>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading analyses...</p>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && !errorMessage">
    <!-- Empty State -->
    <div *ngIf="analyses.length === 0" class="text-center py-5 text-muted">
      <i class="bi bi-graph-up fs-1 d-block mb-3"></i>
      <p>No Agremo analyses found for this organization</p>
    </div>

    <!-- Analyses Table -->
    <div *ngIf="analyses.length > 0">
      <div class="table-responsive">
        <table class="table data-table table-hover mb-0">
          <thead>
            <tr>
              <th>Field</th>
              <th>Analysis Type</th>
              <th>Status</th>
              <th>Requested</th>
              <th>Completed</th>
              <th>Credits</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let analysis of analyses">
              <td>
                <span class="fw-medium">{{ analysis.fieldName || '-' }}</span>
              </td>
              <td>{{ analysis.analysisType || analysis.analysisTypeId || '-' }}</td>
              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(analysis.status)">
                  {{ getStatusLabel(analysis.status) }}
                </span>
              </td>
              <td>{{ formatDateTime(analysis.requestedAt) }}</td>
              <td>{{ formatDateTime(analysis.completedAt) }}</td>
              <td>{{ analysis.creditsConsumed }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Footer -->
      <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalAnalyses > 0">
        <div class="text-muted">
          Showing {{ showingStart }} to {{ showingEnd }} of {{ totalAnalyses }} analyses
        </div>
        <nav *ngIf="totalPages > 1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" (click)="onPageChange(currentPage - 1)">
                <i class="bi bi-chevron-left"></i>
              </button>
            </li>
            <li
              *ngFor="let page of paginationRange"
              class="page-item"
              [class.active]="page === currentPage"
            >
              <button class="page-link" (click)="onPageChange(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link" (click)="onPageChange(currentPage + 1)">
                <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
